import {FC} from 'react'
import {Presenter} from './Presenter'

export const Show: FC = () => {
  return <Presenter />
}
